
/* injects from baggage-loader */

'use strict';

/**
 * Function that register the all routes for the main module.
 *
 * @param {any} $urlRouterProvider
 */
function routeConfig($urlRouterProvider) {
	'ngInject';

	$urlRouterProvider.otherwise('/oops');
}

export default angular
	.module('index.routes', [])
	.config(routeConfig);



// WEBPACK FOOTER //
// ./src/app/index.routes.js